import Icon from "@mui/material/Icon";
import { Theme } from "@mui/material/styles";
import { bool, node, oneOf, string } from "prop-types";
import { ReactNode } from "react";

import timelineItem from "./styles";
import MDBox from "../../MDBox";
import MDTypography from "../../MDTypography";

export type TimelineItemColorType =
  | "transparent"
  | "white"
  | "black"
  | "primary"
  | "secondary"
  | "info"
  | "success"
  | "warning"
  | "error"
  | "light"
  | "dark"
  | "text"
  | "grey-100"
  | "grey-200"
  | "grey-300"
  | "grey-400"
  | "grey-500"
  | "grey-600"
  | "grey-700"
  | "grey-800"
  | "grey-900";

export type TimelineItemProps = {
  color?: TimelineItemColorType;

  icon: ReactNode;
  title: string;
  dateTime: string;
  description?: string;
  lastItem?: boolean;
};

function TimelineItem({
  color = "dark",
  icon,
  title,
  dateTime,
  description = "",
  lastItem = false,
}: TimelineItemProps) {
  return (
    <MDBox position="relative" mb={3} sx={(theme: Theme) => timelineItem(theme, { lastItem })}>
      <MDBox
        display="flex"
        justifyContent="center"
        alignItems="center"
        bgColor={color}
        color="white"
        width="2rem"
        height="2rem"
        borderRadius="section"
        position="absolute"
        top="8%"
        left="2px"
        zIndex={2}
        sx={{ fontSize: 20 }}
      >
        <Icon fontSize="inherit" sx={{ color: "white" }}>
          {icon}
        </Icon>
      </MDBox>
      <MDBox ml={5.75} pt={description ? 0.7 : 0.5} lineHeight={0} maxWidth="30rem">
        <MDTypography variant="button" fontWeight="medium">
          {title}
        </MDTypography>
        <MDBox mt={0.5}>
          <MDTypography variant="caption" color={"text"}>
            {dateTime}
          </MDTypography>
        </MDBox>
        <MDBox mt={2} mb={1.5}>
          {description ? (
            <MDTypography variant="button" color={"white"}>
              {description}
            </MDTypography>
          ) : null}
        </MDBox>
      </MDBox>
    </MDBox>
  );
}

TimelineItem.propTypes = {
  color: oneOf([
    "transparent",
    "white",
    "black",
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
    "text",
    "grey-100",
    "grey-200",
    "grey-300",
    "grey-400",
    "grey-500",
    "grey-600",
    "grey-700",
    "grey-800",
    "grey-900",
  ]),
  icon: node.isRequired,
  title: string.isRequired,
  dateTime: string.isRequired,
  description: string,
  lastItem: bool,
};

export default TimelineItem;
